import { render, staticRenderFns } from "./SelectorAsientosComponent.vue?vue&type=template&id=8ccba076"
import script from "./SelectorAsientosComponent.vue?vue&type=script&lang=js"
export * from "./SelectorAsientosComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports